import React from 'react';
import propTypes from 'prop-types';
import i18n from './i18n';
import img from './error-cone.png';
import mergeI18n from '../../lib/util/merge-i18n';
import preloadImg from '../../lib/util/preload-img';
import { LOG_IN_ROUTE } from '../../constants/constants';

preloadImg(img);

class ErrorNotification extends React.Component {
	componentDidMount () {
		this.props.setParentState({
			progressIndex: -1,
			canLogOut: false,
			canGoToHomePage: true
		});
	}

	render () {
		const __ = mergeI18n(this.props.language ? this.props.language : 'EN', i18n);

		const errorCone = (
			<img className='error-cone' src={img} alt='' />
		);

		return (
			<div id='lss-content' className='container'>
				<div className='row'>
					<div className='col-xs-12'>
						<div id='error-notification' className='row'>
							<div className='col-xs-12 col-centered text-center'>
								{errorCone}
								<h1>{__.heading}</h1>
								<h2>{__.subheading}</h2>
								<div className='directions'>
									<p>{__.paragraph1}</p>
									<p>{__.paragraph2}</p>
								</div>
								<button onClick={() => this.props.setRoute(LOG_IN_ROUTE)} type='button' className='btn btn-primary'>{__.startOver}</button>
							</div>
						</div>
					</div>
				</div>
			</div>
		);
	}
}

ErrorNotification.propTypes = {
	language: propTypes.string.isRequired,
	setParentState: propTypes.func.isRequired,
	setRoute: propTypes.func.isRequired
};
export default ErrorNotification;
